var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('div',{staticClass:"text"},[_vm._v("长按保存图片")]),_c('img',{attrs:{"src":_vm.share.banner}})])}
var staticRenderFns = []

export { render, staticRenderFns }